import { useDownloadFieldReports, UseProjectsParams } from '@/hooks'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { LoadingButton } from '@mui/lab'

export type DownloadFieldReportsProps = {
  filterParams: UseProjectsParams
}

export const DownloadFieldReports = ({
  filterParams,
}: DownloadFieldReportsProps) => {
  const { t } = useTranslation('common')
  const { enqueueSnackbar } = useSnackbar()
  const { doExport, loading: isDownloading } = useDownloadFieldReports()

  const handleExportSubmit = async () => {
    try {
      await doExport(filterParams)

      enqueueSnackbar(t('messages.exportedSuccessfully'), {
        variant: 'success',
      })
    } catch (e) {
      enqueueSnackbar(`${t('errors:api.execute')}: ${e}`, {
        variant: 'error',
      })
    }
  }

  return (
    <LoadingButton
      variant="contained"
      color="secondary"
      loading={isDownloading}
      disableElevation={true}
      disabled={isDownloading}
      onClick={handleExportSubmit}
    >
      <span> {t('buttons.downloadReports')}</span>
    </LoadingButton>
  )
}
